export default {
    url: 'https://drive.google.com/file/d/1rB42YYjJFLB_YB9Z0uQOFt8ePTz1MrY7/view',
};
